<ng-container>
  <mat-form-field id="additional-info-{{ field.label }}">
    <mat-label>{{ field.label }}</mat-label>
    @if (controlType != 2) {
      <div>
        <textarea
          [(ngModel)]="field.value"
          [required]="mandatory"
          [value]="field.value"
          (input)="onChange($event.target.value)"
          matInput
          placeholder="{{ field.label }}"
          pattern=".*\S.*"
        ></textarea>
      </div>
    } @else {
      <mat-select
        [(ngModel)]="field.value"
        [required]="mandatory"
        (selectionChange)="selectValue($event)"
        >
        @for (value of field.readableValue; track value) {
          <mat-option [value]="value">{{
            value
          }}</mat-option>
        }
      </mat-select>
    }
    <button
      [matMenuTriggerFor]="appMenu"
      (click)="onMenuClick($event)"
      mat-icon-button
      matSuffix
      >
      <mat-menu #appMenu="matMenu">
        <button (click)="onEdit()" mat-menu-item>
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>
        <button [disabled]="mandatory" (click)="onRemove()" mat-menu-item>
          <mat-icon>clear</mat-icon>
          <span>Remove</span>
        </button>
      </mat-menu>
      <mat-icon mat-icon-button>more_vert</mat-icon>
    </button>
  </mat-form-field>
</ng-container>
